<template>
	<section class="new-event-hotel-checkout">
	<hotel-booking-resume :booking="bookingRequest"/>

		<div class="new-event-hotel-checkout__payment">
			<credit-card-info
				:country="pax.country"
				:event="event"
				:booking-response="bookingResponse"
				@handlePaymentMethod="$emit('handle-payment-method', $event)"
				@book="$emit('book', $event)"
			>
				<cancel-confirmation-policy
					:booking="bookingRequest"
					:payment-method="paymentMethod"
					@is-agreed-politics-terms="$emit('is-agreed-politics-terms', $event)"
				/>

				<template slot="secondary-action">
					<button type="button" class="new-event-hotel-checkout__back" @click="$emit('back')">
						voltar
					</button>
				</template>
			</credit-card-info>
		</div>
	</section>
</template>

<script>
import CancelConfirmationPolicy from './CancelConfirmationPolicy.vue';
import HotelBookingResume from './HotelBookingResume.vue';
import CreditCardInfo from '../shared/CreditCardInfo.vue';

export default {
	components: {
		CancelConfirmationPolicy,
		HotelBookingResume,
		CreditCardInfo,
	},
	props: {
		bookingRequest: {
			type: Object,
			required: true,
		},
		bookingResponse: {
			type: Object,
			default: null,
		},
		event: {
			type: Object,
			required: true,
		},
		pax: {
			type: Object,
			required: true,
		},
		paymentMethod: {
			type: Object,
			default: null,
		},
	},
};
</script>

<style scoped lang="scss">
.new-event-hotel-checkout {
	box-sizing: border-box;
	width: 100%;
	overflow: hidden;
	border: 1px solid #d7d7d7;
	border-radius: 35px;
	background: #ffffff;
}

.new-event-hotel-checkout__payment {
	padding: 83px 66px 73px;
}

.new-event-hotel-checkout__payment /deep/ .new-payment-info {
	max-width: 1082px;
	margin: 0 auto;
}

.new-event-hotel-checkout__back {
	box-sizing: border-box;
	width: 153px;
	height: 36px;
	border: 1px solid #ff9600;
	border-radius: 10px;
	background: #ffffff;
	color: #ff9600;
	font-family: inherit;
	font-size: 16px;
	font-weight: 700;
	line-height: 19px;
	text-align: center;
	box-shadow: 4px 4px 100px rgba(0, 0, 0, .1);
	cursor: pointer;
}

@media (max-width: 900px) {
	.new-event-hotel-checkout {
		border-radius: 24px;
	}

	.new-event-hotel-checkout__payment {
		padding: 42px 24px 48px;
	}

	.new-event-hotel-checkout__back {
		width: 100%;
		max-width: 153px;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/hotel-reservation/HotelCheckout.vue